// extracted by mini-css-extract-plugin
export default {"root":"EndUserTypography_root__omqR+"};